import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './Pages/Authentication/ProtectedRoute';
import Layout from './Pages/Dashboard/Layout';
import Login from './Pages/Login';
import Register from './Pages/Register';
import UnauthorizedAccess from './Pages/Dashboard/Pages/UnauthorizedAccess';
import ForgotPassword from './Pages/PasswordReset/ForgotPassword';
import OtpVerification from './Pages/PasswordReset/Otp';
import PasswordReset from './Pages/PasswordReset/PasswordReset';
import Users from './Pages/Dashboard/Pages/UserManagement';
import RoomAvailability from './Pages/Dashboard/Pages/RoomAvailability';
import Inventory from './Pages/Dashboard/Pages/Inventory';
import Pricing from './Pages/Dashboard/Pricing/Pricing';
import ModifyFactors from './Pages/Dashboard/Pricing/ModifyFactors';
import Template from './Pages/Dashboard/Pricing/Template';
import DynamicPricing from './Pages/Dashboard/Pricing/PricingOverview';
import RoomManagement from './Pages/Dashboard/RoomManagement';
import Amenities from './Pages/Dashboard/Pages/Amenities';
import Vendors from './Pages/Dashboard/Vendors';
import Housekeeping from './Pages/Dashboard/core-modules/Housekeeping/Housekeeping.jsx';
import Reports from './Pages/Dashboard/InventoryReports';
import Help from './Pages/Dashboard/Pages/Help';
import Settings from './Pages/Dashboard/Pages/Settings';
import RoleRequestTable from './Pages/Dashboard/RoleRequest';
import Dashboard from './Pages/Dashboard/Dashboard';
import PropertyManagement from './Pages/Dashboard/PropertyManagement';
import RevenueManagement from './Pages/Dashboard/core-modules/RevenueManagement.jsx';
import EventBanquet from './Pages/Dashboard/core-modules/EventBanquet/EventBanquet.jsx';
import FinancialAccounting from './Pages/Dashboard/core-modules/FinancialAccounting/FinancialAccounting.jsx';
import SupplyChain from './Pages/Dashboard/core-modules/SupplyChain/SupplyChain.jsx';
import HumanResource from './Pages/Dashboard/core-modules/HumanResource/HumanResource.jsx';
import ModuleSpecific from './Pages/Dashboard/GSTReportsModule.jsx';
import CrossFunctional from './Pages/Dashboard/PoliceVerificationReport.jsx';
import RoomService from './Pages/Dashboard/Amenities/RoomService.jsx';
import OrderFood from './Pages/Dashboard/Amenities/OrderFood.jsx';
import ReservationSearch from './Pages/Dashboard/ReservationSearch.jsx';
import AddRole from './Pages/Dashboard/Role-based/AddRole.jsx';
import ManagePermissions from './Pages/Dashboard/Role-based/ManagePermissions.jsx';
import PricingCalender from './Pages/Dashboard/Pricing/PricingCalender.jsx';
import PricingOverview from './Pages/Dashboard/Pricing/PricingOverview.jsx';
import Preferences from './Pages/Dashboard/Settings/Preferences.jsx';
import Currency from './Pages/Dashboard/Settings/Currency.jsx';
import HotelConfig from './Pages/Dashboard/Settings/HotelConfig.jsx';
import Language from './Pages/Dashboard/Settings/Language.jsx';
import Notification from './Pages/Dashboard/Settings/Notifications.jsx';
import RegionID from './Pages/Dashboard/RegionID.jsx';
import Pms from './Pages/Dashboard/core-modules/Pms.jsx';
import OnlineBookingEngine from './Pages/Dashboard/core-modules/OnlineBookingEngine/OnlineBookingEngine.jsx';
import Pos from './Pages/Dashboard/core-modules/POS/Pos.jsx';
import HousekeepingAndMaintenanceManagement from './Pages/Dashboard/core-modules/Housekeeping/Housekeeping.jsx';
import InventoryDashboard from './Pages/Dashboard/InventoryDashboard.jsx';
import Cash from './Pages/Dashboard/Pages/Cash';
import AddRoomType from './Pages/AddRoomType';
import AccountManagment from './Pages/Dashboard/CustomerManagement/AccountManagment.jsx';
import MenuItemsManagment from './Pages/MenuItemsManagment';
import MenuCategorization from './Pages/Dashboard/Pages/MenuCategorization';
import MenuPricingPromotions from './Pages/Dashboard/Pages/MenuPricingPromotions';
import MenuAnalyticsInsights from './Pages/MenuAnalyticsInsights';
import AddCategory from './Pages/Dashboard/Pages/AddCategory';
import AddSubcategories from './Pages/Dashboard/Pages/AddSubcategories';
import ExistingRoom from './Pages/Dashboard/ExistingRoom';
import TrackOrderFrontdesk from './Pages/TrackOrderFrontdesk';
import TrackOrderKitchen from './Pages/TrackOrderKitchen';
import Reschedule from './Pages/Reschedule';
import Roomupgrade from './Pages/Roomupgrade';
import RoomAssignment from './Pages/Dashboard/RoomAssignment';
import GuestInfo from './Pages/Dashboard/GuestInfo';
import FoodOrder from './Pages/Dashboard/FoodOrder.jsx';
import CancelledBooking from './Pages/Dashboard/CancelledBooking';
import ManageRoomCategories from './Pages/Dashboard/ManageRoomCategories';
import ManageRoomSubcategories from './Pages/Dashboard/ManageRoomSubcategories';
import ManageRoomItems from './Pages/Dashboard/ManageRoomItems';
import FrontdeskRoomservices from './Pages/Dashboard/FrontdeskRoomservices';
import AmenityCategory from './Pages/Dashboard/AmenityCategory';
import AmenitySubCategory from './Pages/Dashboard/AmenitySubCategory';
import AmenityItems from './Pages/Dashboard/AmenityItems';
import FrontDeskAmenities from './Pages/Dashboard/FrontDeskAmenities';
import OrderRoomServices from './Pages/Dashboard/RoomServices/OrderRoomServices';
import AmenityServices from './Pages/Dashboard/Amenities/AmenityServices';
import AuthCallback from './Pages/Authentication/AuthCallback.jsx';
import EmailVerification from './Pages/PasswordReset/EmailVerification.jsx';
import EmailOtp from './Pages/PasswordReset/EmailOtp.jsx';
import AdminOtpVerification from './Pages/Dashboard/AdminFlow/AdminOtpVerification.jsx';
import RegisterProperty from './Pages/Dashboard/AdminFlow/RegisterPropertyAdmin.jsx';
import TwoFactorAuthentication from './Pages/PasswordReset/TwoFactorAuthentication.jsx';
import ComingSoon from './commonComponent/ComingSoon.jsx';
import MaintenanceReport from './Pages/Dashboard/core-modules/Housekeeping/MaintenanceReport.jsx';
import InventoryManagement from './Pages/Dashboard/core-modules/Housekeeping/InventoryManagement.jsx';
import Accounts from './Pages/Dashboard/core-modules/FinancialAccounting/Accounts.jsx';
import FinancialReporting from './Pages/Dashboard/core-modules/FinancialAccounting/FinancialReporting.jsx';
import TaxManagement from './Pages/Dashboard/core-modules/FinancialAccounting/TaxManagement.jsx';
import HumanResourceManagement from './Pages/Dashboard/core-modules/HumanResource/HumanResource.jsx';
import PayrollManagement from './Pages/Dashboard/core-modules/HumanResource/PayrollManagement.jsx';
import EmployeeTraining from './Pages/Dashboard/core-modules/HumanResource/EmployeeTraining.jsx';
import CostControl from './Pages/Dashboard/core-modules/SupplyChain/CostControl.jsx';
import InventoryProcurement from './Pages/Dashboard/core-modules/SupplyChain/Inventory.jsx';
import BillingEvents from './Pages/Dashboard/core-modules/EventBanquet/BillingEvents.jsx';
import RoomLayout from './Pages/Dashboard/core-modules/EventBanquet/RoomLayout.jsx';
import RetailSale from './Pages/Dashboard/core-modules/POS/RetailSale.jsx';
import ChannelManagement from './Pages/Dashboard/core-modules/OnlineBookingEngine/ChannelManagement.jsx';
import PaymentIntegration from './Pages/Dashboard/core-modules/OnlineBookingEngine/PaymentIntegration.jsx';
import MainInventory from './Pages/Dashboard/InventoryManagement/MainInventory.jsx';
import DamageReports from './Pages/Dashboard/DamageReports.jsx';
import FeedbackQueries from './Pages/Dashboard/core-modules/FeedbackAndQueries/FeedbackQueries.jsx';
import FeedbackManagement from './Pages/Dashboard/core-modules/FeedbackAndQueries/FeedbackManagement.jsx';
import QueriesManagement from './Pages/Dashboard/core-modules/FeedbackAndQueries/QueriesManagement.jsx';
import AddFoodItem from './Pages/Dashboard/AddFoodItem';
import AddUser from './Pages/Dashboard/AddUser';
import EditUser from './Pages/Dashboard/EditUser';
import CorporateContractsPage from './Pages/Dashboard/CustomerManagement/CorporateContractsPage.jsx';
import CorporateCreditVerify from './Pages/Dashboard/CustomerManagement/CorporateCreditVerify.jsx';
import CorporateSettings from './Pages/Dashboard/CustomerManagement/CorporateSettings.jsx';
import CorporateOverview from './Pages/Dashboard/CustomerManagement/CorporateOverview.jsx';
import LeisureGuestManagement from './Pages/Dashboard/CustomerManagement/LeisureGuestManagement.jsx';
import VendorManagementOverview from './Pages/Dashboard/VendorManagement/VendorManagementOverview.jsx';
import VendorAccounts from './Pages/Dashboard/VendorManagement/VendorAccounts.jsx';
import CategoriesManagement from './Pages/Dashboard/VendorManagement/CategoriesManagement.jsx';
import PurchaseOrders from './Pages/Dashboard/VendorManagement/PurchaseOrders.jsx';
import Payments from './Pages/Dashboard/VendorManagement/Payments.jsx';
import ContractApprovalsPage from './Pages/Dashboard/CustomerManagement/ContractApprovalsPage.jsx';
import RefundAdjustments from './Pages/Dashboard/Pages/RefundAdjustments.jsx';
import AdjustmentDetailsPage from './Pages/Dashboard/core-modules/FinancialAccounting/AdjustmentDetailsPage.jsx';
import AuditLogs from './Pages/Dashboard/core-modules/FinancialAccounting/AuditLogs.jsx';
import DiningTables from './Pages/Dashboard/DiningTables.jsx';
import GstReportsModule from './Pages/Dashboard/GSTReportsModule.jsx';
import PoliceVerificationReport from './Pages/Dashboard/PoliceVerificationReport.jsx';
import RevenueReport from './Pages/Dashboard/RevenueReport.jsx';
import RoomOccupancyReport from './Pages/Dashboard/RoomOccupancyReport.jsx';
import OrderInvoicing from './Pages/Dashboard/OrderInvoicing.jsx';
import RestaurantReport from './Pages/Dashboard/RestaurantReport.jsx';

// Define routes based on `primaryItems`
const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route path="/admin-otp-verification" element={<AdminOtpVerification />} />
        <Route path="/email-otp-verification" element={<EmailOtp />} />
        <Route path="/register-property" element={<RegisterProperty />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/two-factor-otp-verification" element={<TwoFactorAuthentication />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/comingsoon" element={<ComingSoon />} />
        {/* Protected Routes */}
        <Route path="/dashboard" element={<Layout />}>
          {/* Dashboard Route */}
          <Route
            path=""
            element={
              <ProtectedRoute requiredPermission="Dashboard">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="region"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <RegionID />
              </ProtectedRoute>
            }
          />
          {/* Master Data Management */}
          <Route
            path="mdm/property-management"
            element={
              <ProtectedRoute requiredPermission="Property Management">
                <PropertyManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/room-management/overview"
            element={
              <ProtectedRoute requiredPermission="Overview">
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/room-management/rooms"
            element={
              <ProtectedRoute requiredPermission="Room management">
                <RoomManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/room-management/rooms/addroomtype"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AddRoomType />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/room-management/rooms/addroomtype/existing-roomtype"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <ExistingRoom />
              </ProtectedRoute>
            }
          />

          <Route
            path="mdm/room-management/reservations"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <ReservationSearch />
              </ProtectedRoute>
            }
          />

          <Route
            path="mdm/room-management/order-summary"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <InventoryDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="mdm/users"
            element={
              <ProtectedRoute requiredPermission="User Management">
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/users/add"
            element={
              <ProtectedRoute requiredPermission="User Management">
                <AddUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/users/edit/:userId"
            element={
              <ProtectedRoute requiredPermission="User Management">
                <EditUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/users/manage-roles"
            element={
              <ProtectedRoute requiredPermission="User Management">
                <AddRole />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/users/manage-permissions"
            element={
              <ProtectedRoute requiredPermission="User Management">
                <ManagePermissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/users/role-request"
            element={
              <ProtectedRoute requiredPermission="User Management">
                <RoleRequestTable />
              </ProtectedRoute>
            }
          />

          <Route
            path="mdm/vendor-management"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <VendorManagementOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/vendor-management/accounts"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <VendorAccounts />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="mdm/vendor-management/purchase-orders"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <PurchaseOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/vendor-management/payments"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <Payments />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="mdm/vendor-management/manage-categories"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <CategoriesManagement />
              </ProtectedRoute>
            }
          />
          {/* Customer mgmt */}
          <Route
            path="mdm/customer-management/corporate"
            element={
              <ProtectedRoute requiredPermission="Corporate Accounts">
                <AccountManagment />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/customer-management/leisure"
            element={
              <ProtectedRoute requiredPermission="Leisure Accounts">
                <LeisureGuestManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/customer-management/corporate-overview"
            element={
              <ProtectedRoute requiredPermission="Customer management">
                <CorporateOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/customer-management/contracts"
            element={
              <ProtectedRoute requiredPermission="Contracts">
                <CorporateContractsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/customer-management/contract-approvals"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <ContractApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/customer-management/credit-verification"
            element={
              <ProtectedRoute requiredPermission="Credit & Verification">
                <CorporateCreditVerify />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/customer-management/settings"
            element={
              <ProtectedRoute requiredPermission="Settings">
                <CorporateSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-items-managment"
            element={
              <ProtectedRoute requiredPermission="Menu management">
                <MenuItemsManagment />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-items-managment/add"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AddFoodItem />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-items-managment/add-category"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AddCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-items-managment/add-subcategory"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AddSubcategories />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-categorization"
            element={
              <ProtectedRoute requiredPermission="Menu Categorization">
                <MenuCategorization />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-pricing-promotions"
            element={
              <ProtectedRoute requiredPermission="Pricing & Promotions">
                <MenuPricingPromotions />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/menu-analytics-insights"
            element={
              <ProtectedRoute requiredPermission="Analytics & Insights">
                <MenuAnalyticsInsights />
              </ProtectedRoute>
            }
          />

          <Route
            path="mdm/amenities-management/room-service"
            element={
              <ProtectedRoute requiredPermission="Room service">
                <RoomService />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/room-service/manage-room-categories"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <ManageRoomCategories />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/room-service/manage-room-subcategories"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <ManageRoomSubcategories />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/room-service/manage-roomitems"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <ManageRoomItems />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/amenities"
            element={
              <ProtectedRoute requiredPermission="Amenities management">
                <Amenities />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/amenities/manage-amenity-category"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AmenityCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/amenities/manage-amenity-subcategory"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AmenitySubCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/amenities-management/amenities/manage-amenity-items"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <AmenityItems />
              </ProtectedRoute>
            }
          />
          <Route
            path="mdm/inventory-management"
            element={
              <ProtectedRoute requiredPermission="Master Data Management">
                <MainInventory />
              </ProtectedRoute>
            }
          />
          {/* Core Modules */}
          <Route
            path="core-modules/property-management-system"
            element={
              <ProtectedRoute requiredPermission="Property management">
                <Pms />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-operations"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <ReservationSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="guest/:guestId"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <GuestInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-operations/manage-rooms"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <RoomAssignment />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-operations/cancelled-booking"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <CancelledBooking />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-operations/damage-reports"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <DamageReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/guest-managment"
            element={
              <ProtectedRoute requiredPermission="Guest Management">
                <RoomAvailability />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-roomservices"
            element={
              <ProtectedRoute requiredPermission="Hospitality Services">
                <FrontdeskRoomservices />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-roomservices/room-services-booking"
            element={
              <ProtectedRoute requiredPermission="Hospitality Services">
                <OrderRoomServices />
              </ProtectedRoute>
            }
          />

          <Route
            path="core-modules/property-management-system/front-desk-amenities"
            element={
              <ProtectedRoute requiredPermission="Facility Services">
                <FrontDeskAmenities />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-amenities/amenities-booking"
            element={
              <ProtectedRoute requiredPermission="Facility Services">
                <AmenityServices />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/billing-payments"
            element={
              <ProtectedRoute requiredPermission="Billing & Payments">
                <Cash />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/refunds-adjustments"
            element={
              <ProtectedRoute requiredPermission="Billing & Payments">
                <RefundAdjustments />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/revenue-management"
            element={
              <ProtectedRoute requiredPermission="Revenue Management">
                <RevenueManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/feedback&queries/feedback-management"
            element={
              <ProtectedRoute requiredPermission="Feedback Management">
                <FeedbackManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="core-modules/feedback&queries/queries-management"
            element={
              <ProtectedRoute requiredPermission="Queries Management">
                <QueriesManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/online-booking-engine"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <OnlineBookingEngine />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/online-booking-engine/channel-management"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <ChannelManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/online-booking-engine/payment-gateway"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <PaymentIntegration />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/pos/retail-pos"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <Pos />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/pos/restaurant-bar-billing"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <RetailSale />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/banquet-management/event-planning"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <EventBanquet />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/banquet-management/event-billing"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <BillingEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/banquet-management/room-layout-capacity"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <RoomLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/finance/billing-invoicing"
            element={
              <ProtectedRoute requiredPermission="Billing & Invoicing">
                <FinancialAccounting />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/finance/accounts-receivable-payable"
            element={
              <ProtectedRoute requiredPermission="Accounts">
                <Accounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/finance/financial-reporting"
            element={
              <ProtectedRoute requiredPermission="Financial Reporting">
                <FinancialReporting />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/finance/adjustment-details"
            element={
              <ProtectedRoute requiredPermission="Billing & Invoicing">
                <AdjustmentDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/finance/tax-management"
            element={
              <ProtectedRoute requiredPermission="Tax Management">
                <TaxManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/finance/audit-logs"
            element={
              <ProtectedRoute requiredPermission="Audit Logs">
                <AuditLogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/supply-chain/vendor-management"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <SupplyChain />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/supply-chain/inventory-procurement"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <InventoryProcurement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/supply-chain/cost-control-budgeting"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <CostControl />
              </ProtectedRoute>
            }
          />

          <Route
            path="core-modules/hrm/staff-scheduling"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <HumanResourceManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/hrm/payroll-management"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <PayrollManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/hrm/employee-training"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <EmployeeTraining />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/housekeeping-management"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <HousekeepingAndMaintenanceManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/housekeeping-management/maintenance-report"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <MaintenanceReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/housekeeping-management/inventory-management"
            element={
              <ProtectedRoute requiredPermission="Core Modules">
                <InventoryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/f&b-management/order-food"
            element={
              <ProtectedRoute requiredPermission="Order Food">
                <FoodOrder />
              </ProtectedRoute>
            }
          />

          <Route
            path="core-modules/f&b-management/track-order-frontdesk"
            element={
              <ProtectedRoute requiredPermission="Orders">
                <TrackOrderFrontdesk />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/f&b-management/track-order-kitchen"
            element={
              <ProtectedRoute requiredPermission="Order Processing Panel">
                <TrackOrderKitchen />
              </ProtectedRoute>
            }
          />

          <Route
            path="core-modules/f&b-management/dining-tables"
            element={
              <ProtectedRoute requiredPermission="Order Processing Panel">
                <DiningTables />
              </ProtectedRoute>
            }
          />

          <Route
            path="core-modules/f&b-management/order-invoicing"
            element={
              <ProtectedRoute requiredPermission="Order Processing Panel">
                <OrderInvoicing />
              </ProtectedRoute>
            }
          />

          {/* Pricing */}
          <Route
            path="core-modules/revenue-management/pricing-overview"
            element={
              <ProtectedRoute requiredPermission="Pricing">
                <PricingOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/revenue-management/pricing-template"
            element={
              <ProtectedRoute requiredPermission="Template">
                <Template />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/revenue-management/modify-factors"
            element={
              <ProtectedRoute requiredPermission="Pricing Factors">
                <ModifyFactors />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/revenue-management/pricing"
            element={
              <ProtectedRoute requiredPermission="pricing">
                <Pricing />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/revenue-management/room-rates"
            element={
              <ProtectedRoute requiredPermission="Room Rates">
                <PricingCalender />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-operations/reschedule"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <Reschedule />
              </ProtectedRoute>
            }
          />
          <Route
            path="core-modules/property-management-system/front-desk-operations/room-upgrade"
            element={
              <ProtectedRoute requiredPermission="Front Desk Operations">
                <Roomupgrade />
              </ProtectedRoute>
            }
          />
          {/* System Configurations */}
          <Route
            path="system-config/wide-settings"
            element={
              <ProtectedRoute requiredPermission="System Configurations">
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-config/preferences"
            element={
              <ProtectedRoute requiredPermission="System Configurations">
                <Preferences />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-config/notifications"
            element={
              <ProtectedRoute requiredPermission="System Configurations">
                <Notification />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-config/language"
            element={
              <ProtectedRoute requiredPermission="System Configurations">
                <Language />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-config/currency"
            element={
              <ProtectedRoute requiredPermission="System Configurations">
                <Currency />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-config/hotel-config"
            element={
              <ProtectedRoute requiredPermission="System Configurations">
                <HotelConfig />
              </ProtectedRoute>
            }
          />

          <Route
            path="reports/gst-reports"
            element={
              <ProtectedRoute requiredPermission="GST Reports">
                <GstReportsModule />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports/police-verification-reports"
            element={
              <ProtectedRoute requiredPermission="Police Verification Reports">
                <PoliceVerificationReport />
              </ProtectedRoute>
            }
          />

          <Route
            path="reports/revenue-reports"
            element={
              <ProtectedRoute requiredPermission="Revenue Reports">
                <RevenueReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports/room-occupancy-reports"
            element={
              <ProtectedRoute requiredPermission="Room Occupancy Reports">
                <RoomOccupancyReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports/restaurant-reports"
            element={
              <ProtectedRoute requiredPermission="Restaurant Reports">
                <RestaurantReport />
              </ProtectedRoute>
            }
          />

          {/* Help */}
          <Route
            path="help"
            element={
              <ProtectedRoute requiredPermission="Help">
                <Help />
              </ProtectedRoute>
            }
          />
          {/* Unauthorized */}
          <Route path="unauthorized" element={<UnauthorizedAccess />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
